import { render } from "./PopoverContent.vue?vue&type=template&id=61baf71f"
import script from "./PopoverContent.vue?vue&type=script&lang=js"
export * from "./PopoverContent.vue?vue&type=script&lang=js"

import exportComponent from "D:\\MAMP\\htdocs\\electra\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__